import { BsCalendar2 } from "react-icons/bs";

const styles = {
  fechaContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
};

function Fecha({ fecha }) {
  const [year, month, day] = fecha.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const opciones = { day: "numeric", month: "long", year: "numeric" };
  const fechaFormateada = date.toLocaleDateString("es-ES", opciones);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <BsCalendar2 size={18} />
      <span className="fs-6">{fechaFormateada}</span>
    </div>
  );
}


export default Fecha;
